var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcArrowLeft = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.323,
    height: 31.907,
    viewBox: "0 0 27.323 31.907",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "6ax7rw9zka",
    x: 0,
    y: 0,
    width: 27.323,
    height: 31.907,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#6ax7rw9zka)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2934",
    d: "m12036.139-583.459-6.1-5.646 6.1-6.1",
    transform: "translate(-12018.88 602.27)",
    style: {
      fill: "none",
      stroke: "#3e3e3e",
      strokeWidth: 3
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcArrowLeft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-arrowLeft.1f63d61ad10fe4a14229a87c9317419e.svg";